import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { HttpHeaders } from '@angular/common/http';

import { ResellerModel } from '@models/index'
import { environment } from '@environments/environment';


@Injectable({
    providedIn: 'root',
})
export class ResellersService {
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
        })
    };
    constructor(
        private http: HttpClient
    ) { }

    searchResellers(): Observable<ResellerModel[]> {
        return this.http
        .get(`${environment.apiPath}/resellers`)
        .pipe(
          map(data =>  data as ResellerModel[])
        );
    }

    searchResellersByQuery(query: string): Observable<ResellerModel[]> {
        return this.http
        .get(`${environment.apiPath}/resellers/autocomplete?query=${query}`)
        .pipe(
          map(data =>  data as ResellerModel[])
        );
    }

    createReseller(reseller: ResellerModel): Observable<ResellerModel> {
        return this.http
        .post(`${environment.apiPath}/resellers`,  reseller , this.httpOptions)
        .pipe(
            map(data => data as ResellerModel)
        );
    }

    deleteReseller(resellerId: string): Observable<string> {
        return this.http
        .post<string>(`${environment.apiPath}/resellers/${resellerId}`, this.httpOptions)
    }

    editReseller(reseller: ResellerModel) {
        return this.http
        .post(`${environment.apiPath}/resellers/edit`,  reseller)
        .pipe(
            map(data => data as ResellerModel)
        );
    }

    editResellerAvailableLicenses(reseller: ResellerModel) {
        return this.http
        .post(`${environment.apiPath}/resellers/admin-edit`,  reseller)
        .pipe(
            map(data => data as ResellerModel)
        );
    }

    archiveReseller(resellerId: string): Observable<string> {
        return of(resellerId)
    }
}
